import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/tosh/Projects/personal/cashplay/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FAQPage"] */ "/Users/tosh/Projects/personal/cashplay/wisprs/src/components/faq-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/Users/tosh/Projects/personal/cashplay/wisprs/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/Users/tosh/Projects/personal/cashplay/wisprs/src/components/navigation.tsx");
